import _createClass from "/home/runner/work/merkle-express/merkle-express/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/runner/work/merkle-express/merkle-express/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/runner/work/merkle-express/merkle-express/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/runner/work/merkle-express/merkle-express/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import Connector from "@walletconnect/core";
import * as cryptoLib from "@walletconnect/iso-crypto";

var WalletConnect = /*#__PURE__*/function (_Connector) {
  _inherits(WalletConnect, _Connector);

  var _super = _createSuper(WalletConnect);

  function WalletConnect(connectorOpts, pushServerOpts) {
    _classCallCheck(this, WalletConnect);

    return _super.call(this, {
      cryptoLib: cryptoLib,
      connectorOpts: connectorOpts,
      pushServerOpts: pushServerOpts
    });
  }

  return _createClass(WalletConnect);
}(Connector);

export default WalletConnect;